import patrocinadorOasis from '../assets/sponsors/patrocinadoresOasis.png';
import patrocinioDos from '../assets/sponsors/2.png';
import patrocinioTres from '../assets/sponsors/3.png';
import patrocinioCuatro from '../assets/sponsors/4.png';
import apps from '../assets/sponsors/publicidadOasisApp.png';
import publicidadMundial2016 from '../assets/sponsors/publicidadOasisAppMundial2026.png';

const width = '100%';

export const sponsorsData = [
  // {
  //   image: publicidadMundial2016,
  //   alt: 'Publicidad Oasis App Mundial 2026',
  //   link: '/login',
  //   widthImg: width,
  // },
  // {
  //   image: apps,
  //   alt: 'plataformas apps',
  //   link: '/#DownloadAppSection',
  //   widthImg: width,
  // },
  {
    image: patrocinioCuatro,
    alt: 'Anunciate Aquí',
    link: 'mailto:contacto@oasisapp.mx',
    widthImg: width,
  },
  {
    image: patrocinadorOasis,
    alt: 'Oaseas',
    link: 'https://oaseas.mx/',
    widthImg: width,
  },
  {
    image: patrocinioDos,
    alt: 'Oaseas',
    link: 'https://oaseas.mx/destino/1',
    widthImg: width,
  },
  {
    image: patrocinioTres,
    alt: 'Oaseas',
    link: 'https://oaseas.mx/destino/2',
    widthImg: width,
  }
];